import {useEffect, useState} from "react";
import "css/frontend/jsoftMenu.css";

export function JsoftMenu(props){

    //console.log(props);


    const [activeTab, setActiveTab] = useState("tab1");
  //  Functions to handle Tab Switching
  const handleTab1 = () => {
    // update the state to tab1
    setActiveTab("tab1");
  };
  const handleTab2 = () => {
    // update the state to tab2
    setActiveTab("tab2");
  };

  const handleTab3= () => {
    // update the state to tab2
    setActiveTab("tab3");
  };

  const handleTab4 = () => {
    // update the state to tab2
    setActiveTab("tab4");
  };

  const handleTab5 = () => {
    // update the state to tab2
    setActiveTab("tab5");
  };

  const handleTab6 = () => {
    // update the state to tab2
    setActiveTab("tab6");
  };

  const handleTab7 = () => {
    // update the state to tab2
    setActiveTab("tab7");
  };

    
    // When the user scrolls the page, execute myFunction
    useEffect(() => {
        const handleScroll = event => {
            const header = document.getElementById("myHeader");


            const infgen = document.getElementById("infgen");
            const caltrafil = document.getElementById("caltrafil");
            const ruttrafil = document.getElementById("ruttrafil");
            const prinmerd = document.getElementById("prinmerd");
            const esptraf = document.getElementById("esptraf");
            const modope = document.getElementById("modope");
            const factimptrafil = document.getElementById("factimptrafil");
            
           // console.log("header",header.offsetTop);
          // console.log('window.scrollY', window.pageYOffset);
            if (window.pageYOffset > header.offsetTop + 600) {
               header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
                setActiveTab("tab1");
            }
            //estilos
            if (window.pageYOffset > infgen.offsetTop - 100) {
              setActiveTab("tab1");
            }

             if (window.pageYOffset > caltrafil.offsetTop - 100) {
              setActiveTab("tab2");
            } 

            if (window.pageYOffset > ruttrafil.offsetTop - 100) {
              setActiveTab("tab3");
            } 

            if (window.pageYOffset > prinmerd.offsetTop - 100) {
              setActiveTab("tab4");
            } 

            if (window.pageYOffset > esptraf.offsetTop - 100) {
              setActiveTab("tab5");
            } 

            if (window.pageYOffset > modope.offsetTop  - 100) {
              setActiveTab("tab6");
            } 

            if (window.pageYOffset > factimptrafil.offsetTop - 100) {
              setActiveTab("tab7");
            } 
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
  //window.onscroll = function() {myFunction()};
  
  // Get the header
  
  
  // Get the offset position of the navbar
  //var sticky = header.offsetTop;
  
  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  
  
  
  
    return(
        <div  className="header" id="myHeader">
           <aside className="menu">
                
                <ul className="menu-list">
                  <li><a href="#infgen"  className={activeTab === "tab1" ? "menu-active" : ""}  onClick={handleTab1}>Información General</a></li>
                  <li><a href="#caltrafil"  className={activeTab === "tab2" ? "menu-active" : ""}  onClick={handleTab2}>Puntos de Calor de Tráfico Ilegal</a></li>
                  <li><a href="#ruttrafil" className={activeTab === "tab3" ? "menu-active" : ""}  onClick={handleTab3}>Rutas de Tráfico Ilegal de Especies</a></li>
                  <li><a href="#prinmerd" className={activeTab === "tab4" ? "menu-active" : ""}   onClick={handleTab4}>Demandas y Especímenes</a></li>
                  <li><a href="#esptraf" className={activeTab === "tab5" ? "menu-active" : ""}  onClick={handleTab5}>Otras Especies Traficadas ilegalmente</a></li>
                  <li><a href="#modope" className={activeTab === "tab6" ? "menu-active" : ""}  onClick={handleTab6}>Modus Operandi</a></li>
                  <li><a href="#factimptrafil"  className={activeTab === "tab7" ? "menu-active" : ""}  onClick={handleTab7}> Factores que Impulsan el Tráfico Ilegal de Especies</a></li>
                </ul>               
              </aside>
      </div>
    );
  }